<template>
  <modal-container
    v-if="modelValue"
    iconSize="50px"
    :iconColor="'#36B079'"
    icon="mdi-cloud-check"
    :gap="'30px'"
    :borderRadius="'20px'"
    :padding="'40px'"
    :title="$t('SingelInvoice.printModalTitle')"
  >
    <Backdrop @close-model="closeModal" :bgColor="'#00000061'"> </Backdrop>
    <div class="d-flex flex-column ga-5 align-center">
      <div class="modal-content">
        {{ $t("SingelInvoice.printModalContent") }}
        <span class="email">{{ userEmail }}</span>
      </div>
      <v-btn class="close-modal-btn" flat @click="closeModal">
        <div class="d-flex align-center ga-1">
          <v-icon size="24" color="black" icon="mdi-close-circle-outline" />
          <span> {{ $t("SingelInvoice.printModalCloseBtn") }}</span>
        </div>
      </v-btn>
    </div>
  </modal-container>
</template>

<script>
import ModalContainer from "@/components/UI/modals/modal-container.vue";
import Backdrop from "@/components/UI/backdrop.vue";

export default {
  components: {
    ModalContainer,
    Backdrop,
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    userEmail: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("update:modelValue", false);
    },
  },
};
</script>

<style scoped lang="scss">
.modal-content {
  font-size: $mediumTextSize;
  color: $modalContentColor;
  font-weight: 400;
  line-height: 21.33px;
  text-align: center;
  margin-top: -20px;

  .email {
    color: #36b079;
  }
}
.close-modal-btn {
  font-size: $smallTextSize;
  color: #000000;
  font-weight: 400;
}

.close-modal-btn {
  display: inline-flex;
  align-items: center;
  border: 1px solid $borderColor;
  background: $primaryBackgroundColor;

  font-size: $smallTextSize;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: right;
  border-radius: 15px;
  padding: 25px;
  color: black;
  max-width: max-content;

  border: i {
    margin-right: 10px;
  }
  i:lang(en) {
    padding-right: 10px;
    transform: rotate(180deg);
  }
}

.close-modal-btn {
  padding: 25px 40px;
}
</style>
